import * as React from 'react'
import { Descriptions, Button, Result, Spin } from 'antd'
import styled from 'styled-components'
import { FormattedMessage, FormattedDate } from 'react-intl'
import { ShowInvoiceItems } from '../Bills/ShowInvoiceItems'
import DiscountBlock from './DiscountBlock'
import TaxBlock from './TaxBlock'
import AmountBlock from './AmountBlock'
import { useCurrentInvoice } from './queries'

const PaymentContent = styled(Spin)`
  height: 100%;
  display: flex;
  flex-direction: column;
  & .ant-descriptions-item-content {
    width: 100%;
  }
`

const Spacer = styled.div`
  flex: 1;
`

const FullWidthItem = styled.div`
  width: 100%;
  & > .ant-spin-nested-loading {
    width: 100%;
    white-space: nowrap;
  }
`

const Payment = ({ next }: { next: () => void }) => {
  const invoiceQuery = useCurrentInvoice()
  const invoice = invoiceQuery.data

  return (
    <PaymentContent spinning={invoiceQuery.isLoading}>
      {invoice?.status !== 'PAID' ? (
        <Descriptions layout="vertical" column={1}>
          <Descriptions.Item label={<FormattedMessage id="items" />}>
            <ShowInvoiceItems
              items={invoice?.items ?? []}
              unitID={invoice?.unitID ?? ''}
            />
          </Descriptions.Item>
          {invoiceQuery.isSuccess && !!invoiceQuery.data.discount && (
            <Descriptions.Item label={<FormattedMessage id="discount" />}>
              <FullWidthItem>
                <DiscountBlock />
              </FullWidthItem>
            </Descriptions.Item>
          )}
          {invoiceQuery.isSuccess && !!invoiceQuery.data.tax && (
            <Descriptions.Item label={<FormattedMessage id="tax" />}>
              <FullWidthItem>
                <TaxBlock />
              </FullWidthItem>
            </Descriptions.Item>
          )}
          <Descriptions.Item label={<FormattedMessage id="amount" />}>
            <AmountBlock />
          </Descriptions.Item>
          <Descriptions.Item label={<FormattedMessage id="reference" />}>
            {invoice?.reference}
          </Descriptions.Item>
          <Descriptions.Item label={<FormattedMessage id="dueDate" />}>
            <FormattedDate
              value={invoice?.createdAt}
              year="numeric"
              month="long"
              day="numeric"
            />
          </Descriptions.Item>
        </Descriptions>
      ) : (
        <Result title={<FormattedMessage id="invoicePaid" />} />
      )}
      <Spacer />
      <Button
        disabled={invoice?.status !== 'UNPAID'}
        onClick={next}
        type="primary"
      >
        <FormattedMessage id="next" />
      </Button>
    </PaymentContent>
  )
}

export default Payment
